<!-- 业务商品列表 -->
<template>
    <div class='page_content'>
        <div class="page_content_top">
            <v-button :buttonList="buttonList" :buttonFlag="false" :showRefresh="false" :btnFlag="false">
                <template slot="button">
                    <div>
                        <el-button type="primary" size="mini" @click="actionSet(4)">保存</el-button>
                        <el-button type="primary" size="mini" @click="actionSet(3)">导出</el-button>
                        <el-button type="primary" size="mini" @click="actionSet(1)">下载模版</el-button>
                        <el-button type="primary" size="mini" @click="actionSet(2)">导入</el-button>
                    </div>
                </template>
            </v-button>
            <div class="page_content_top_line">
                <el-form @submit.native.prevent :inline="true" label-width="100px" :model="getRequestData" class="demo-form-inline" size="mini">
                    <el-form-item label="通用名称">
                        <label slot="label" :style="$common.labelStyle('通用名称')" v-html="'通用名称'"></label>
                        <el-input class="form_codition" @keyup.enter.native="searchData" v-model.trim="getRequestData.bgmName" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="规格">
                        <label slot="label" :style="$common.labelStyle('规格')" v-html="'规格'"></label>
                        <el-input class="form_codition" @keyup.enter.native="searchData" v-model.trim="getRequestData.spec" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="生产厂商">
                        <label slot="label" :style="$common.labelStyle('生产厂商')" v-html="'生产厂商'"></label>
                        <el-input class="form_codition" @keyup.enter.native="searchData" v-model.trim="getRequestData.manufacturer" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="入库单号">
                        <label slot="label" :style="$common.labelStyle('入库单号')" v-html="'入库单号'"></label>
                        <el-input class="form_codition" @clear="clear('psbkmId')" clearable v-model="getRequestData.psbkmId" @keyup.enter.native="openSearch(820873997127716, 0, 'psbkmId', 'psbkmId')">
                            <el-button @click="openSearch(820873997127716, 0, 'psbkmId', 'psbkmId')" slot="append" icon="el-icon-search"></el-button>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="商品名称">
                        <label slot="label" :style="$common.labelStyle('商品名称')" v-html="'商品名称'"></label>
                        <el-input class="form_codition" @keyup.enter.native="searchData" v-model.trim="getRequestData.bgiGename" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="装量">
                        <label slot="label" :style="$common.labelStyle('装量')" v-html="'装量'"></label>
                        <el-input class="form_codition" v-model.trim="getRequestData.goodReserves4" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="品牌">
                        <label slot="label" :style="$common.labelStyle('品牌')" v-html="'品牌'"></label>
                        <el-input class="form_codition" v-model.trim="getRequestData.bgiBrand" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="mini" @click="searchData">查询</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="page_content_center">
            <el-table :key="tableFlag" stripe @selection-change="handleSelectionChange" :data="returnData.list" :height="tableHeight" border style="width: 100%" highlight-current-row size="mini">
                <!-- 主信息 -->
                <el-table-column type="selection" width="40"></el-table-column>
                <el-table-column v-for="(tableValye, tableKey) in pageShowData" :key="tableKey" align="center" :prop="tableValye.entityField" :label="tableValye.showField" show-overflow-tooltip :min-width="tableValye.fieldWeight"
                    :fixed="tableValye.fixed||false">
                    <template slot-scope="scope">
                        <span v-if="tableValye.fieldType == 'date'">
                            <span v-if="scope.row[tableValye.entityField]">
                                {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                            </span>
                        </span>
                        <span v-else-if="tableValye.isRift == 1">
                            <a @click="toDetail(scope.row[tableValye.riftField])">{{
                                        scope.row[tableValye.entityField] }}</a>
                        </span>
                        <el-input clearable style="width: 90px;margin: 0 1px;" @blur="blur(scope.$index, tableValye.entityField)" v-else-if="tableValye.fieldType == 'input'" type="number"
                            v-model="scope.row[tableValye.entityField]"></el-input>
                        <span v-else>
                            {{ scope.row[tableValye.entityField] }}
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName"></SearchScheme>
        </el-dialog>
        <!-- 自定义设计 -->
        <customDesign ref="customDesign"></customDesign>
        <el-dialog title="导入" :visible.sync="importShow" width="30%" append-to-body modal-append-to-body>
            <initDataUpload :parentSearchData="importObj" :url="url" :importType="importType" @fileSuccess='fileSuccess' @closeExcel="closeExcel">
            </initDataUpload>
        </el-dialog>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import nameList from "./businessPriceMaintain.js";
import SearchScheme from "../../byComponents/SearchScheme.vue";
export default {
    //import引入的组件需要注入到对象中才能使用
    components: { SearchScheme },
    data() {
        //这里存放数据
        return {
            tableHeight: 0,
            tableFlag: 0,
            getRequestData: {
                spec: "",
                bgmName: "",
                page: 1,
                rows: 30,
                manufacturer: "",
                psbkmId: "",
                bgiGename: "",
                goodReserves4: "",
                bgiBrand: "",
            },
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: [],
            },
            buttonList: [],
            pageShowData: {},
            selectData: [],
            parentSearchData: {},
            seId: "",
            sField: "",
            DialogVisible: false,
            seWidth: "",
            seTitle: "",
            importShow: false,
            importType: "",
            url: "",
            importObj: {
                ormId: "",
                opmId: "",
            }
        };
    },
    //监听属性 类似于data概念
    //方法集合
    methods: {
        clear(val) {
            if (val) {
                var arr = val.split(",")
                arr.forEach(item => {
                    this.$set(this.getRequestData, item, "")
                })
            }
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1;
                this.getRequestData.end = time;
            }
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, type, sField) {
            this.DialogVisible = true;
            this.seId = sId;
            this.sField = sField;
            this.parentSearchData[type] = this.getRequestData[type];
        },
        // 赋值字段
        paramValue(val) {
            console.log(this.sField);
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.getRequestData[item] = val[item];
            });
        },
        //检索带回数据
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.paramValue(val);
            }
        },
        blur(index, index1) {
            console.log(this.returnData.list[index][index1]);
            var num = String(this.returnData.list[index][index1])
            if (num.indexOf(".") != -1 && num.split('.')[1].length >= 10) {
                this.returnData.list[index][index1] = this.$common.getDecimalInfo(2, this.returnData.list[index][index1])
            }

        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页    
                var isPenetrate = true
                // 设置缓存 存入点击单号
                this.resetSetItem('penetrateOrderId', orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage({ //向窗口发送MessageEvent消息
                    cmd: 'returnFormJson',
                    params: {
                        isPenetrate
                    } //参数
                }, '*');
            }
        },
        async actionSet(actionType) {
            switch (actionType) {
                case 4:
                    if (this.selectData.length == 0) {
                        return this.$message.error("请选择数据")
                    }
                    this.save()
                    break;
                case 3:
                    this.getRequestData.page = 1;
                    await this.getDataList();
                    if (this.returnData.list.length == 0) return this.$message.warning("暂无导出数据")
                    window.location.href = `${this.$store.getters.getConfig.requestUrl}/BusinessGood/exportGoodsMaintain${this.$common.getUrl({ ormId: JSON.parse(sessionStorage.getItem("loginInfo")).ormId, ...this.getRequestData })}`
                    break;
                case 1:
                    window.location.href = `${window.global_config.BASE_URL}/BusinessGood/downloadImportTemp?ormId=${sessionStorage.getItem('ormId')}`
                    break;
                case 2:
                    this.importType = 'importGoodsMaintain'
                    this.url = 'BusinessGood/importGoodsMaintain'
                    this.importObj.ormId = JSON.parse(sessionStorage.getItem("userInfo")).ormId
                    this.importObj.opmId = JSON.parse(sessionStorage.getItem("userInfo")).opmId
                    this.importShow = true
                    break;
                default:
                    break;
            }
        },
        // 触发组件的提交
        fileSuccess(val) {
        },
        // 关闭弹窗
        closeExcel(val) {
            if (val) {
                this.importShow = false
                this.getDataList()
            }
        },
        //保存
        async save() {
            var arr = []
            this.selectData.forEach(item => {
                arr.push(
                    {
                        bgmId: item.bgmId,
                        suggestedPrice: item.suggestedPrice,
                        lowestPrice: item.lowestPrice,
                        lastPirce: item.lastPirce,
                        priceList: []
                    }
                )
            })
            this.selectData.forEach((item, index) => {
                for (const key in item) {
                    if (key.indexOf('levlePrice') != -1) {
                        arr[index].priceList.push({
                            levleId: Number(key.split("_")[1]),
                            levlePrice: item[key] === '' ? 0 : this.$common.getDecimalInfo(2, item[key]),
                            levleName: key.split("_")[2],
                        })
                    }
                }
                item.priceList.forEach((item1, index1) => {
                    arr[index].priceList[index1] ? this.$set(arr[index].priceList[index1], "oldPrice", item1.levlePrice) : ''
                })
            })
            const responseData = await this.$http.updateGoodsPrice(arr)
            console.log(responseData);
            if (responseData.status == 200) {
                this.$message.success("操作成功")
                this.getDataList()
            } else {
                this.$message.error(responseData.message)
            }
        },
        handleSelectionChange(val) {
            this.selectData = val
            console.log(this.selectData);
        },
        // 数据搜索
        searchData() {
            this.getRequestData.page = 1;
            this.getDataList();
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val;
            this.getDataList();
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1;
            this.getRequestData.rows = val;
            this.getDataList();
        },
        async getPriceStrategyGroup() {
            let responseData = await this.$http.getPriceStrategyGroup();
            var namelist = responseData.result
            this.pageShowData = JSON.parse(JSON.stringify(nameList))
            if (window.global_config.businessPriceMaintainShow) {
                this.pageShowData.forEach(item => {
                    item.fixed = false
                })
            }
            this.pageShowData.push({
                entityField: "lowestPrice",
                showField: "最低售价",
                fieldWeight: 120,
                fieldType: "input"
            },
                {
                    entityField: "suggestedPrice",
                    showField: "建议售价",
                    fieldWeight: 120,
                    fieldType: "input"
                },)

            namelist.forEach(item => {
                this.pageShowData.push({
                    entityField: 'levlePrice_' + item.levleId + "_" + item.levleName,
                    showField: item.levleName,
                    fieldWeight: 120,
                    fieldType: "input",
                    levleId: item.levleId
                })
            })
            this.getDataList()
        },
        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.queryGoodsMaintain(this.getRequestData);
            if (responseData.status == 200) {
                console.log(responseData);
                var list = responseData.result.list;
                if (list.length > 0) {
                    list.forEach((item) => {
                        item.priceList.forEach(item1 => {
                            this.$set(item, 'levlePrice_' + item1.levleId + "_" + item1.levleName, item1.levlePrice === '' ? 0 : item1.levlePrice)
                        })
                    })
                }
                this.returnData.list = list
                this.returnData.pages = responseData.result.pages;
                this.returnData.total = responseData.result.total;
                this.returnData.pageNum = responseData.result.pageNum;
                this.$nextTick(() => {
                    this.tableHeight = this.$common.getTableHeight()
                    this.tableFlag++
                })
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        var obj = this.$common.getSearch(this.getRequestData, '', '', 'page', 'rows', 30)
        for (const key in obj) {
            this.$set(this.getRequestData, key, obj[key])
        }
        this.getPriceStrategyGroup()
        // this.getDataList()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.$nextTick(() => {
            this.tableHeight = this.$common.getTableHeight()
            this.tableFlag++
        })
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() {
        this.tableHeight = this.$common.getTableHeight()
    }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped></style>